export default function getKioskUrl(deviceId: string) {
    return `https://kiosk-viewer.web.app/?mode=view&deviceId=${deviceId}&t=${new Date().getTime()}`;
}